import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class CsvExportService {

  constructor(private snackBar: MatSnackBar) { }

  download(data: string, fileName: string, options?: CsvExportOptions): void {
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, fileName);
    this.snackBar.open('Data downloaded successfully.', 'Close', { duration: 3000 });
  }

  downloadDataAsCsv(data: any[], fileName: string): void {
    if (!data || data.length === 0) {
      this.snackBar.open('No data to download.', 'Close', { duration: 3000 });
      return;
    }
    const csvData = this.convertToCsv(data);
    const options = {
      headers: Object.keys(data[0]),
      fieldSeparator: ','
    };
    this.download(csvData, fileName, options);
  }

  private convertToCsv(data: any[]): string {
    let csv = '';
    const headers = Object.keys(data[0]);
    const nonEmptyHeaders = headers.filter(header => {
      for (const row of data) {
        if (row[header] !== '' && !row[header] !== undefined) {
          return true;
        }
      }
      return false;
    });
    csv += nonEmptyHeaders.join(',') + '\n';
    for (const row of data) {
      const values = [];
      for (const header of nonEmptyHeaders) {
        const value = row[header] || '';
        if (typeof value === 'string' && value.includes(',')) {
          values.push(`"${value}"`);
        } else {
          values.push(value);
        }
      }
      csv += values.join(',') + '\n';
    }
    return csv;
  }
  

}

export interface CsvExportOptions {
  headers?: string[];
  fieldSeparator?: string;
}

